import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import styled from 'styled-components'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import { rem } from 'polished'

const Grid = styled.div`
  display: grid;
  grid-template-columns: ${rem(100)} 1fr;
  grid-template-rows: 1fr;
  height: ${rem(115)};
  width: ${rem(312)};
`

const StyledSheetTransparent = styled(Sheet)`
  background: rgba(255,255,255, 0.16);
`

const StyledLoadingImageBox = styled(LoadingBox)`
  width: 100%;
  height: 100%;
`

const StyleLoadingBox = styled(LoadingBox)`
  width: 100%;
  height: ${rem(20)};
`

function TripCarouselCardsLoading() {
  return (
    <Grid>
      <StyledLoadingImageBox height={115} borderRadius="S" />
      <StyledSheetTransparent padding="16 16 16 16" paletteType="inverse">
        <Group direction="vertical" gap={12}>
          <StyleLoadingBox borderRadius="S" />
          <StyleLoadingBox borderRadius="S" height={51} />
        </Group>
      </StyledSheetTransparent>
    </Grid>
  )
}

export default TripCarouselCardsLoading
